import { render, staticRenderFns } from "./CoverYearCCR.vue?vue&type=template&id=80272ff8"
import script from "./CoverYearCCR.vue?vue&type=script&lang=js"
export * from "./CoverYearCCR.vue?vue&type=script&lang=js"
import style0 from "./CoverYearCCR.vue?vue&type=style&index=0&id=80272ff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports